<button mat-stroked-button [color]="color" [ngClass]="{ 'no-border': !border }">
  <mat-icon>{{ icon }}</mat-icon> {{ textKey | locLabel | capitalize }}
</button>
